import { styled } from '@mui/material/styles';

export const SectionsContainer = styled('div')(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'grid',
  gridGap: theme.spacing(3.75),
  gridTemplateColumns: '100%',
  padding: `${theme.spacing(5)} 0 ${theme.spacing(7)} 0`,
  '@media (min-width: 860px)': {
    gridTemplateColumns: 'minmax(450px, 2fr) minmax(320px, 1fr)'
  }
}));

export const CompetenceContainer = styled('div')(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'grid',
  gridGap: theme.spacing(3.75),
  gridTemplateColumns: '100%',
  padding: `${theme.spacing(5)} 0 0 0`
}));

export const ButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  color: theme.color.primary.main,
  alignItems: 'center',
  '& .wexp-add-bottom': {
    color: theme.color.primary.main
  }
}));

export const Button = styled('button')(() => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: 0,
  fontSize: '13px',
  marginRight: '5px',
  '&:focus': {
    outline: 'none'
  }
}));

export const ContentWrapper = styled('div')(({ togglerPosition }) => ({
  display: 'flex',
  flexDirection: togglerPosition === 'top' ? 'column-reverse' : 'column',
  width: '100%'
}));

export const ExpandCollapseContainer = styled('div')(() => ({
  justifyContent: 'space-between',
  flexDirection: 'column',
  display: 'flex'
}));

export const Label = styled('span')(({ theme }) => ({
  fontWeight: theme.fontWeight.normal,
  marginRight: theme.spacing(0.5),
  color: theme.color.primary.main
}));

export const ToggleIcon = styled('span')(() => ({
  fontSize: '2em',
  transform: 'rotate(270deg)'
}));

export const TogglerContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: theme.spacing(3)
}));
